<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.columns {
  padding-bottom: 40px;
}
.instructions {
}
.keys {
  // background: white;
  // border: 1px solid hsl(0, 0, 85);
  // padding: 20px;
}
pre {
  padding: 0px;
}
</style>

<template>
  <c-layout>
    <template #title>Credentials</template>

    <template #content>
      <div class="columns">
        <div class="column">
          <div class="heading">AWS Key</div>
          <div class="keys is-size-6 is-family-monospace">
            Key: {{user.key}}<br>
            Secret:
            <span class="pr-3" v-if="user.secret">{{user.secret}}</span>
            <a href="#" @click.prevent="drawer=true" class="has-text-primary">regenerate</a>
            <br>
            Table: {{user.tag}}<br>
            Region: {{user.region}}<br>
          </div>
        </div>
        <div class="column instructions">
          <div class="heading">About your Credentials</div>
          <div class="is-size-6">
            Your credentials give you direct access to your data in the secure Amazon cloud.  Your secret key will only
            be visible the first time you create your credentials.  If you lost your secret key click regenerate to
            invalidate your old credentials and create a new key.
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="heading">Using your credentials</div>
          <div class="is-size-6">
            <p class="pb-3">
            In order to access your data using your credentials you must connect to the Amazon Cloud and read data
            from the DynamoDB table where your data is stored. Below is an example Python3 script that can be used
            to test your credentials.
            </p>
            <pre v-highlightjs="tail"><code class="python"></code></pre>
          </div>
        </div>
      </div>
    </template>

    <template #drawer>
      <c-drawer v-show="drawer" @close="drawer=null">
        <rekey-form @complete="drawer=null"></rekey-form>
      </c-drawer>
    </template>
  </c-layout>
</template>

<script>
import { get } from 'vuex-pathify';
import tail from 'raw-loader!./tail.py';
import RekeyForm from './rekey-form';


export default {
  name: 'keys',
  data() {
    return {
      drawer: false,
      tail
    };
  },
  components: {
    RekeyForm
  },
  computed: {
    user: get('user')
  }
};
</script>
